:host {
  --aha-box--background-color: var(--theme-secondary-background);
  --aha-box--border-radius: var(--Common--border-radius);

  display: block;
  border-radius: var(--aha-box--border-radius);
  background-color: var(--aha-box--background-color);
  margin: 2em 0;
}

:host([nested]) {
  --aha-box--background-color: var(--theme-primary-background);
}

.aha-box--padding-medium {
  padding: 2em;
}

.aha-box--padding-small {
  padding: 1em;
}

.aha-box--padding-none {
  padding: 0em;
}
